/* @flow */

import { compose } from 'ramda';
import { connect } from 'react-redux';

import TopicCardDumb from './TopicCardDumb';
import { getSelf } from 'src/shared/domain/user/selector/userSelectors';

import type { Conversation } from '@e180/domain/lib/conversation/type';
import type { Topic } from '@e180/domain/lib/topic/type';

type Props = {
  conversation?: Conversation,
  topic: Topic,
  isTopicDisabled: ?boolean,
  isRejected?: boolean,
  animate?: boolean,
  trackFMP?: boolean,
  handleClick?: () => void,
  handleAnimatedCardUnmount?: () => void,
};

const mapStateToProps = (state: Object, ownProps: Props): Object => {
  const {
    conversation,
    topic,
    isTopicDisabled,
    isRejected,
    animate,
    trackFMP,
    handleClick,
    handleAnimatedCardUnmount,
  } = ownProps;

  return {
    user: getSelf(state),
    conversation,
    topic,
    isTopicDisabled,
    isRejected,
    animate,
    trackFMP,
    handleClick,
    handleAnimatedCardUnmount,
  };
};

export default compose(connect(mapStateToProps))(TopicCardDumb);
